/**
 * Include your custom JavaScript here.
 *
 * Theme event hooks remain available:
 *
 *   document.addEventListener('variant:changed', function (event) {
 *     var variant = event.detail.variant; // the full variant payload
 *   });
 *
 *   document.addEventListener('product:added', function (event) {
 *     var variant  = event.detail.variant;
 *     var quantity = event.detail.quantity;
 *   });
 *
 *   document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *     bubbles: true,
 *     detail: { quantity: 1 }
 *   }));
 *
 *   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *     bubbles: true
 *   }));
 */

(function () {
  'use strict';

  // -------------------------------------------------------------------------
  // 1. Slideshow accessibility - keep off-screen Flickity slides out of the
  //    tab order so keyboard users don't tab into hidden content.
  // -------------------------------------------------------------------------
  function fixSlideshowTabIndex() {
    document.querySelectorAll('.flickity-slider > [aria-hidden="true"]').forEach(function (slide) {
      slide.setAttribute('tabindex', '-1');
      slide.querySelectorAll('a, button, input, select, textarea').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
    });
    document.querySelectorAll('.flickity-slider > :not([aria-hidden="true"])').forEach(function (slide) {
      slide.removeAttribute('tabindex');
      slide.querySelectorAll('a, button, input, select, textarea').forEach(function (el) {
        el.removeAttribute('tabindex');
      });
    });
  }

  // -------------------------------------------------------------------------
  // 2. Judge.me carousel arrow labels.
  // -------------------------------------------------------------------------
  function labelJudgeMeArrows() {
    var arrows = document.querySelectorAll('.jdgm-arrow');
    if (!arrows.length) return;
    arrows.forEach(function (btn) {
      if (btn.getAttribute('aria-label')) return;
      var onclick = btn.getAttribute('onclick') || '';
      if (/previous/i.test(onclick)) {
        btn.setAttribute('aria-label', 'Previous review');
      } else if (/next/i.test(onclick)) {
        btn.setAttribute('aria-label', 'Next review');
      }
    });
  }

  // -------------------------------------------------------------------------
  // 3. Reduced-motion respect.
  // -------------------------------------------------------------------------
  function honourReducedMotion() {
    try {
      var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!mq.matches) return;
      document.querySelectorAll('[data-section-type="slideshow"] .flickity-enabled').forEach(function (el) {
        if (el.flickity && typeof el.flickity.stopPlayer === 'function') {
          el.flickity.stopPlayer();
        }
      });
    } catch (err) {}
  }

  // -------------------------------------------------------------------------
  // 4. Logbase upsell a11y shims:
  //    - label unlabelled checkboxes
  //    - promote the upsell <h3> to <h2> (heading-order audit)
  // -------------------------------------------------------------------------
  function labelLogbaseCheckboxes(root) {
    var scope = root || document;
    var boxes = scope.querySelectorAll
      ? scope.querySelectorAll('.lb-spc-details-checkbox')
      : [];
    if (!boxes.length) return;
    boxes.forEach(function (input) {
      if (input.getAttribute('aria-label')) return;
      if (input.labels && input.labels.length) return;
      var row = input.closest ? input.closest('.lb-spc-body, .lb-spc-cont') : null;
      var title = row && row.querySelector
        ? (row.querySelector('.lb-spc-title, .lb-spc-product-title') || {}).textContent
        : null;
      var label = title ? ('Include "' + title.trim() + '" in bundle')
                        : 'Include this item in bundle';
      input.setAttribute('aria-label', label);
    });
  }

  function promoteLogbaseHeadings(root) {
    var scope = root || document;
    // Match the upsell title and any sibling Logbase title shipped as h3 or h4
    var headings = scope.querySelectorAll
      ? scope.querySelectorAll('h3.lb-upsell-title, h4.lb-upsell-title, h3.ppcse-title')
      : [];
    if (!headings.length) return;
    headings.forEach(function (h) {
      // Already promoted? Stop.
      if (h.tagName.toLowerCase() === 'h2') return;
      var h2 = document.createElement('h2');
      // Preserve every attribute (class, id, style, etc.) so Logbase CSS
      // continues to match exactly.
      for (var i = 0; i < h.attributes.length; i++) {
        var attr = h.attributes[i];
        h2.setAttribute(attr.name, attr.value);
      }
      h2.innerHTML = h.innerHTML;
      h.parentNode.replaceChild(h2, h);
    });
  }

  function watchForLogbase() {
    if (!('MutationObserver' in window)) return;
    var host = document.querySelector('.lb-spc-cont, [class*="lb-spc"], [class*="lb-upsell"]');
    if (!host) {
      var bodyObs = new MutationObserver(function () {
        if (document.querySelector('.lb-spc-cont, [class*="lb-spc"], [class*="lb-upsell"]')) {
          bodyObs.disconnect();
          watchForLogbase();
        }
      });
      bodyObs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { bodyObs.disconnect(); }, 30000);
      return;
    }
    labelLogbaseCheckboxes(host);
    promoteLogbaseHeadings(host);
    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          labelLogbaseCheckboxes(n);
          promoteLogbaseHeadings(n);
        });
      });
    });
    obs.observe(host, { childList: true, subtree: true });
  }

  // -------------------------------------------------------------------------
  // 5. Expandable-content focus management - mirror aria-hidden onto inert.
  // -------------------------------------------------------------------------
  function syncInert(el) {
    if (!el || !el.setAttribute) return;
    var hidden = el.getAttribute('aria-hidden') === 'true';
    if (hidden) {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  }

  function watchExpandableContent() {
    if (!('MutationObserver' in window)) return;
    var targets = document.querySelectorAll('.expandable-content');
    if (!targets.length) return;
    targets.forEach(function (el) {
      syncInert(el);
      var obs = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
            syncInert(m.target);
          }
        });
      });
      obs.observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  // -------------------------------------------------------------------------
  // 6. Duplicate ARIA ID de-duper (payment icons rendered twice on PDP).
  // -------------------------------------------------------------------------
  function dedupePaymentIconIds() {
    var seen = Object.create(null);
    document.querySelectorAll('[id^="pi-"]').forEach(function (el) {
      var id = el.id;
      seen[id] = (seen[id] || 0) + 1;
      if (seen[id] === 1) return;
      var newId = id + '-' + seen[id];
      var svg = el.closest ? el.closest('svg') : null;
      el.id = newId;
      if (svg && svg.getAttribute('aria-labelledby') === id) {
        svg.setAttribute('aria-labelledby', newId);
      }
    });
  }

  // -------------------------------------------------------------------------
  // Boot
  // -------------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    fixSlideshowTabIndex();

    var slider = document.querySelector('.flickity-slider');
    if (slider && 'MutationObserver' in window) {
      new MutationObserver(fixSlideshowTabIndex).observe(slider, {
        attributes: true,
        subtree: true,
        attributeFilter: ['aria-hidden']
      });
    }

    labelJudgeMeArrows();
    setTimeout(labelJudgeMeArrows, 1500);

    honourReducedMotion();

    watchForLogbase();

    watchExpandableContent();

    dedupePaymentIconIds();
  });

  // Re-run helpers if Shopify section reloads in the theme editor.
  document.addEventListener('shopify:section:load', function () {
    fixSlideshowTabIndex();
    labelJudgeMeArrows();
    labelLogbaseCheckboxes();
    promoteLogbaseHeadings();
    watchExpandableContent();
    dedupePaymentIconIds();
  });
})();
